import React, { useRef, useEffect } from 'react';
import './WebApps.css';

const apps = [
  {
    name: 'Converter',
    href: '?converter',
    description: 'Convert and merge files, many formats, nothing leaves your machine.',
  },
  {
    name: 'ARTyping',
    href: '?artyping',
    description: 'Turn any photograph into typewriter art, right in your browser.',
  },
  {
    name: 'Gallery',
    href: '?gallery',
    description: 'Film photographs, filterable by subject and stock.',
  },
  {
    name: 'QR Generator',
    href: '?qr',
    description: 'Custom QR codes with color and a clean transparent export.',
  },
  {
    name: 'Phone Words',
    href: '?phonewords',
    description: 'Turn any phone number into words you can actually remember.',
  },
  {
    name: 'Business Card',
    href: '?card',
    description: 'My calling card. Flip it, tap it, save my details.',
  },
];

export default function WebApps({ isOpen, onClose }) {
  const panelRef = useRef(null);
  const returnFocusRef = useRef(null);

  // Focus the panel when it opens so Escape key works; return focus on close
  useEffect(() => {
    if (isOpen && panelRef.current) {
      returnFocusRef.current = document.activeElement;
      panelRef.current.focus();
    } else if (!isOpen && returnFocusRef.current) {
      returnFocusRef.current.focus?.();
      returnFocusRef.current = null;
    }
  }, [isOpen]);

  return (
    <>
      {/* Backdrop */}
      <div
        className={`wa-backdrop ${isOpen ? 'wa-backdrop--visible' : ''}`}
        onClick={onClose}
      />

      {/* Panel */}
      <aside
        ref={panelRef}
        className={`wa-panel ${isOpen ? 'wa-panel--open' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-label="Web Applications"
        aria-hidden={!isOpen}
        tabIndex={-1}
        onKeyDown={(e) => e.key === 'Escape' && onClose()}
      >
        <div className="wa-paper">

          {/* Close button */}
          <button className="wa-close" onClick={onClose} title="Close web apps">✕</button>

          <div className="wa-bill">

            {/* Playbill masthead */}
            <div className="wa-masthead">
              <p className="wa-masthead__kicker">Now Showing</p>
              <div className="wa-rule wa-rule--double" />
              <h1 className="wa-masthead__title">Web Applications</h1>
              <div className="wa-rule wa-rule--double" />
              <p className="wa-masthead__performances">
                Live in your browser &nbsp;·&nbsp; No downloads
              </p>
            </div>

            {/* Billings */}
            <ul className="wa-billings">
              {apps.map((app, i) => (
                <li className="wa-billing" key={app.href}>
                  {i > 0 && <div className="wa-rule wa-rule--thin" />}
                  <h2 className="wa-billing__name">{app.name}</h2>
                  <p className="wa-billing__desc">{app.description}</p>
                  <a href={app.href} className="wa-billing__link">
                    Launch {app.name} <span className="kutz-icon" aria-hidden="true">D</span>
                  </a>
                </li>
              ))}
            </ul>

            <div className="wa-rule wa-rule--double" />

          </div>
        </div>
      </aside>
    </>
  );
}
